// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSuitcaseIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M20.15 8H16V5c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v3H3.85C2.83 8 2 8.83 2 9.85v8.3C2 19.17 2.83 20 3.85 20h16.3c1.02 0 1.85-.83 1.85-1.85v-8.3C22 8.83 21.17 8 20.15 8M10 6h4v2h-4zm3 9-3-3v-2h2l3 3z" />
  </g>
);
export default SvgSuitcaseIcon;
SvgSuitcaseIcon.displayName = 'SvgSuitcaseIcon';
